<template>
  <v-container fluid class="list-page">

    <Create :createDialog="createDialog" @close="createDialog = false" @submit="getList"></Create>
    <Edit :editDialog="editDialog" @close="editDialog = false" @submit="getList"
      :editDonationCategory="selectedDonationCategory"></Edit>
    <div class="list-page-heading">
      <div><div class="list-page-heading__eyebrow">Payment routing</div><h1>Payment categories</h1><p>Organize payment purposes and choose which merchant account processes each one.</p></div>
      <div class="list-page-heading__actions"><v-btn v-if="checkRightStatus(85)" color="primary" depressed @click="add"><v-icon left>mdi-plus</v-icon>New category</v-btn></div>
    </div>
    <v-alert outlined color="primary" icon="mdi-information-outline" class="mb-6">School Fee and Donation are required categories and cannot be deleted. You can still assign their merchant account to control where payments are processed.</v-alert>
    <v-card :loading="loading" elevation="0" class="list-card">

      <div class="list-toolbar"><v-text-field v-model="search" class="list-toolbar__search" outlined prepend-inner-icon="mdi-magnify" dense background-color="#F8FAF8" placeholder="Search payment categories" single-line hide-details clearable /><div class="list-toolbar__actions"><v-btn icon outlined color="primary" :loading="loading" aria-label="Refresh categories" @click="getList"><v-icon size="19">mdi-refresh</v-icon></v-btn></div></div>
        <v-data-table class="list-table list-table--responsive" :headers="headers" :items="donationCategories" :search="search" :loading="loading"
          :sort-by="sortBy" :page.sync="page" :items-per-page="itemsPerPage">
          <template v-slot:item="{ item }">
            <tr class="list-table-row">
              <!-- <td class="text-left">{{ item.createdAt | moment('MM/DD/YYYY') }}</td> -->
              <td class="text-left" data-label="Category">
                <div class="list-cell-primary">
                <span v-html="$options.filters.highlight(item.name, search.toLowerCase())
                  ">{{ item.name }}</span>
                </div><div class="list-cell-secondary">{{ item.isLock ? 'Required category' : 'Custom category' }}</div></td>

              <td class="text-left" data-label="Merchant account">
                <div v-if="item.MerchantAccount"><span class="list-cell-primary">{{ item.MerchantAccount.name }}</span><v-chip x-small label class="ml-2" :color="item.MerchantAccount.provider === 'STRIPE' ? 'indigo lighten-5' : 'amber lighten-4'">{{ item.MerchantAccount.provider === 'STRIPE' ? 'Stripe' : 'PayCompass' }}</v-chip></div><span v-else class="grey--text">Not assigned</span>
              </td>

              <td data-label="Status"><v-chip v-if="item.isLock" small outlined color="indigo"><v-icon left small>mdi-lock-outline</v-icon>Required</v-chip><v-chip v-else small outlined color="success">Custom</v-chip></td>
              <td data-label="Actions" class="justify-end align-center text-right action-cell">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="menu-button">
                    <v-list-item v-if="checkRightStatus(87)" @click="editDonationCategory(item)">
                      <v-list-item-title>{{
                        $t("buttons.edit")
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="!item.isLock && checkRightStatus(88)" @click="deleteDonationCategory(item)">
                      <v-list-item-title>{{
                        $t("buttons.delete")
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <template v-slot:no-data><div class="list-empty-state py-12"><v-icon size="48" color="grey lighten-1">mdi-shape-outline</v-icon><strong>No payment categories</strong><span>Create a category and connect it to a merchant account.</span></div></template>
        </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import donationCategoryService from "../service";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");

export default {
  name: "donationCategory-list",
  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedDonationCategory: null,
      headers: [
        // {
        //     text: this.$t("labels.date"),
        //     align: "left",
        //     value: "createdAt",
        //     sortable: true,
        //     width: '30%',
        //   },
        {
          text: this.$t("labels.name"),
          align: "left",
          value: "name",
          sortable: true,
          width: '30%',
        },
        {
          text: "Merchant Account",
          value: "MerchantAccount.name",
          align: "left",
          sortable: true,
        },
        { text: "Status", value: "isLock", sortable: true },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      donationCategories: [],
      search: "",
      loading: true,
      page: 1,
      sortBy: "name",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    if (this.$route.query && this.$route.query.search) {
      this.search = this.$route.query.search;
    }
    document.title = "taleem - DonationCategory";
  },
  components: {
    Create,
    Edit,
  },
  filters: {
    highlight(words, query) {
      if (query) {
        var check = new RegExp(query.toLowerCase(), "ig");
        if (words) {
          return words.toString().replace(check, function (matchedText) {
            return '<span class="highlight">' + matchedText + "</span>";
          });
        } else {
          return words;
        }
      } else {
        return words;
      }
    },
  },
  watch: {
    search(val) {
      if (!val) {
        this.search = "";
      }
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      this.editDialog = false;
      // console.log("this. vd", this.editDialog)
      this.createDialog = false;
      return donationCategoryService.getAll().then((response) => {
        console.log('response donation', response)
        this.loading = false;
        this.donationCategories = response.data;
        return response;
      });
    },
    editDonationCategory(donationCategory) {
      this.selectedDonationCategory = donationCategory;
      this.editDialog = !this.editDialog;
    },
    deleteDonationCategory(donationCategory) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          donationCategoryService.delete(donationCategory.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Donation Category has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
